export default "__VITE_ASSET__Bjfe7cML__"